import { TranslatePipe } from '../i18n/translate.pipe';
import { Component, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-cookie-banner',
  standalone: true,
  imports: [TranslatePipe,CommonModule],
  templateUrl: './cookie-banner.html',
  styleUrls: ['./cookie-banner.scss']
})
export class CookieBannerComponent implements OnInit {
  private readonly platformId = inject(PLATFORM_ID);
  public isVisible: boolean = false;

  ngOnInit() {
    // Si aucun choix n'a été fait par le passé, on affiche la bannière
    if (!isPlatformBrowser(this.platformId)) return;
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      this.isVisible = true;
    }
  }

  acceptAll() {
    if (isPlatformBrowser(this.platformId)) localStorage.setItem('cookieConsent', 'accepted');
    this.isVisible = false;
  }

  rejectAll() {
    if (isPlatformBrowser(this.platformId)) localStorage.setItem('cookieConsent', 'rejected');
    this.isVisible = false;
  }
}
